class FabricDetails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      const compareAllButton = e.target.closest('[data-compare-all]');

      if (!compareAllButton) return;

      compareAllButton.dispatchEvent(new CustomEvent('markup-modal:open', { bubbles: true, detail: { target: this.modalId } }));
    });
  }

  connectedCallback() {
  }

  disconnectedCallback() {
  }

  get modalId() {
    return this.getAttribute('modal-id');
  }
}

if (!customElements.get("fabric-details")) {
  customElements.define("fabric-details", FabricDetails);
}
